<template>
  <div style="position: relative">
    <v-expand-transition>
      <v-row align="center" v-show="expandFilter" v-if="showFilter">
        <v-col>
          <v-autocomplete
            label="Lokalita"
            v-model="filterLokalitaId"
            :items="lokality"
            item-text="Name"
            item-value="ID"
            clearable
          >
          </v-autocomplete>
        </v-col>
        <v-col>
          <v-autocomplete
            label="Bod"
            v-model="filterBodId"
            :items="body"
            item-text="ZNMB"
            item-value="ID"
            clearable
          >
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.ZNMB }} - {{ item.IDMB }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <b>Dátum od:</b> {{ item.DatumOdString }}
                </v-list-item-subtitle>
                <v-list-item-subtitle>
                  <b>Dátum do:</b> {{ item.DatumDoString }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col>
          <date-picker
            v-model="filterDatumOd"
            label="Dátum od"
            name="filterDatumOd"
          ></date-picker>
        </v-col>
        <v-col>
          <date-picker
            v-model="filterDatumDo"
            label="Dátum do"
            name="filterDatumDo"
          ></date-picker>
        </v-col>
      </v-row>
    </v-expand-transition>
    <v-overlay :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
    <div v-if="tableItems.length > 0">
      <v-data-table
        :headers="meranieHeaders"
        :items="tableItems"
        :items-per-page.sync="tableItemsPerPage"
        sort-by="ID"
        @click:row="showItem($event)"
        class="elevation-1 clickableTable"
        :custom-sort="customSort"
        fixed-header
        ref="merTable"
        :height="tableHeight"
      >
      </v-data-table>
      <div class="text-right">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <download-excel :data="tableItems" class="exportXLS">
              <v-icon v-on="on">mdi-microsoft-excel</v-icon>
            </download-excel>
          </template>
          <span>Export do xls</span>
        </v-tooltip>
      </div>
      <div v-if="isLimited" style="font-size: small">
        Zoznam je obmedzený na 10 000 položiek kvôli šetreniu systémových
        prostriedkov.
        <v-btn small @click="setNoLimit()">Načítať všetky položky</v-btn>
      </div>
      <v-btn @click="deleteAll()">Vymazať všetky položky</v-btn>
      <meranie-dialog
        :typ="typ"
        :editable="editable"
        ref="dialogMeranie"
        @change="fetchTableItems"
        @delete="deletedItem"
      />
    </div>
  </div>
</template>

<script>
import * as Miscella from "../plugins/miscella.js"
import * as Enums from "../plugins/enums.js"
//import * as moment from "moment"
import MeranieDialog from "../components/MeranieDialog.vue"
import DownloadExcel from "vue-json-excel"
import DatePicker from "../components/DatePicker.vue"

export default {
  name: "MeranieTable",
  props: {
    typ: {
      type: String,
      required: true,
      validator: function(value) {
        let found = false
        for (const t in Enums.TYPY) {
          if (value === Enums.TYPY[t]) {
            found = true
          }
        }
        if (!found) {
          console.error("Typ " + value + " does not exist")
        }
        return found
      }
    },
    itemsCount: {
      type: Number,
      default: 0
    },
    bodId: {
      type: Number,
      default: 0
    },
    editable: {
      type: Boolean,
      default: true
    },
    showFilter: {
      type: Boolean,
      default: false
    },
    expandFilter: {
      type: Boolean,
      default: false
    }
  },
  components: { MeranieDialog, DownloadExcel, DatePicker },
  data: function() {
    return {
      tableItemsPerPage: 10,
      tableItems: [],
      loading: false,
      customSort: Miscella.customSort,
      bodyNames: [],
      // expandFilter: false,
      filterDatumDo: "",
      filterDatumOd: "",
      filterLokalitaId: "",
      filterBodId: "",
      filterLimit: "YES",
      lokality: [],
      body: []
    }
  },
  computed: {
    tableHeight: function() {
      let ret = 800
      if (this.tableItemsPerPage !== -1) {
        ret = "auto"
      }
      return ret
    },
    meranieHeaders: function() {
      let arr = Enums.getHeaders(this.typ)
      if (this.bodId === 0) {
        arr.splice(2, 0, { text: "Bod", value: "BodZNMB", align: "left" })
        arr.splice(2, 0, {
          text: "Lokalita",
          value: "LokalitaName",
          align: "left"
        })
      }
      return arr
    },
    isLimited: function() {
      let ret = false
      if (this.tableItems.length === 10000 && this.filterLimit === "YES") {
        ret = true
      }
      return ret
    }
  },
  watch: {
    typ: {
      immediate: true,
      handler: async function(value) {
        console.log("MERANIE_TABLE, typ changed, fetching items...", value)
        this.tableItems = []
        this.bodyNames = []
        this.filterDatumDo = ""
        this.filterDatumOd = ""
        this.filterLokalitaId = ""
        this.filterBodId = ""
        this.filterLimit = "YES"
        this.lokality = []
        this.body = []

        if (this.bodId === 0) {
          await this.fetchBodyNames()
          this.readLokality()
        }
        this.fetchTableItems()
      }
    },
    itemsCount: {
      immediate: false,
      handler: function(value) {
        console.log(
          "MERANIE_TABLE, itemsCount changed, fetching items...",
          value
        )
        if (this.tableItems.length !== value) {
          this.fetchTableItems()
        }
      }
    },
    filterLokalitaId: {
      immediate: true,
      handler: function() {
        console.log(
          "MERANIE_TABLE.VUE, filterLokalitaId changed, fetching items..."
        )
        this.filterBodId = ""
        this.readBody()
        this.fetchTableItems()
      }
    },
    filterBodId: {
      immediate: false,
      handler: function() {
        console.log("MERANIE_TABLE.VUE, filterBodId changed, fetching items...")
        this.fetchTableItems()
      }
    },
    filterDatumOd: {
      immediate: false,
      handler: function() {
        console.log(
          "MERANIE_TABLE.VUE, filterDatumOd changed, fetching items..."
        )
        this.fetchTableItems()
      }
    },
    filterDatumDo: {
      immediate: false,
      handler: function() {
        console.log(
          "MERANIE_TABLE.VUE, filterDatumDo changed, fetching items..."
        )
        this.fetchTableItems()
      }
    }
  },
  methods: {
    fetchTableItems: async function() {
      try {
        this.loading = true
        //this.tableItems = []
        let response = await this.$axios.get(
          this.meranieUrl(Enums.getTableURL(this.typ) + "/" + this.bodId)
        )
        if (response.status === 200) {
          // await Miscella.sleep()
          this.tableItems = this.transformItems(response.data)
          this.$emit("loaded", this.tableItems)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      this.loading = false
    },
    transformItems: function(items) {
      let typy = Enums.getTypItems(this.typ)
      let numberTypy = typy.filter(i => i.typ === "number")
      items.forEach(item => {
        item.DatumString = Miscella.formatDatumACas(item.Datum)
        item.DatumOdString = Miscella.formatDatum(item.DatumOd)
        item.DatumDoString = Miscella.formatDatum(item.DatumDo)
        let znmb = ""
        let lokalitaname = ""
        if (Miscella.isSet(this.bodyNames[item.BodID])) {
          znmb = this.bodyNames[item.BodID].znmb
          lokalitaname = this.bodyNames[item.BodID].lokalitaname
        }
        item.BodZNMB = znmb
        item.LokalitaName = lokalitaname
        for (let i = 0; i < numberTypy.length; i++) {
          const nh = numberTypy[i]
          item[nh.value + "String"] = Miscella.formatNumber(item[nh.value])
        }
      })
      return items
    },
    showItem: function(item) {
      console.log("MERANIE_TABLE, showItem", this.$refs.merTable)
      this.$refs.dialogMeranie.show(item)
    },
    deletedItem: function() {
      console.log("MERANIE_TABLE, deletedItem")
      this.fetchTableItems()
      this.$emit("delete")
    },
    setNoLimit: function() {
      this.filterLimit = "NO"
      this.fetchTableItems()
    },
    fetchBodyNames: async function() {
      try {
        let response = await this.$axios.get("/bodynames")
        if (response.status === 200) {
          // await Miscella.sleep()
          this.bodyNames = response.data
          this.$emit("loaded", this.bodyNames)
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
      this.loading = false
    },
    readLokality: async function() {
      try {
        this.lokality = []
        let response = await this.$axios.get(
          `/r/lokality/mer_${Enums.getTableName(this.typ)}`
        )
        if (response.status === 200) {
          this.lokality = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readBody: async function() {
      try {
        console.log("MeranieTable.vue, readBody, id=" + this.filterLokalitaId)
        this.body = []
        if (
          Miscella.isSet(this.filterLokalitaId) &&
          this.filterLokalitaId !== ""
        ) {
          let response = await this.$axios.get(
            `/r/body/${this.filterLokalitaId}/mer_${Enums.getTableName(
              this.typ
            )}`
          )
          if (response.status === 200) {
            let body = response.data
            for (let i = 0; i < body.length; i++) {
              let bod = body[i]
              bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
              bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
              bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
              bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
            }
            this.body = body
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    meranieUrl: function(aUrl) {
      if (this.bodId !== 0) {
        this.filterBodId = this.bodId
      }
      let ret = ""
      let url = Miscella.url(aUrl)
      url.searchParams.append(
        "filterLokalitaId",
        Miscella.normalizeString(this.filterLokalitaId)
      )
      url.searchParams.append(
        "filterBodId",
        Miscella.normalizeString(this.filterBodId)
      )
      ret = Miscella.normalizeString(this.filterDatumOd)
      ret = ret.substr(ret, ret.indexOf("T"))
      url.searchParams.append("filterDatumOd", ret)
      ret = Miscella.normalizeString(this.filterDatumDo)
      ret = ret.substr(ret, ret.indexOf("T"))
      url.searchParams.append("filterDatumDo", ret)
      url.searchParams.append(
        "limit",
        Miscella.normalizeString(this.filterLimit)
      )
      return url.toString()
    },
    deleteAll: async function() {
      if (confirm("Naozaj vymazať všetky zobrazené merania z databázy ?")) {
        try {
          let response = await this.$axios.delete(
            this.meranieUrl("/r/merania/" + Enums.getTableName(this.typ))
          )
          if (response.status === 200) {
            this.fetchTableItems()
            this.$emit("delete")
            this.$store.commit(
              "message",
              "Bolo vymazaných " + response.data + " meraní."
            )
          } else {
            this.$store.commit("alert", response.data.Error)
          }
        } catch (error) {
          this.$store.commit("alert", error.toString())
        }
      }
    }
  }
}
</script>
